import React, { useEffect, useState } from 'react';
import styles from './CommunityPage.module.scss';
import ProfCommunityPage from './ProfCommunity';
import MyCommunityPage from './MyCommunity';
import { Box } from '@mui/material';
import TabSelect from 'components/Tabs';
import { useSearchParams } from 'react-router-dom';

const isProduction = process.env.REACT_APP_ENV === 'production';
const TABS = !isProduction
  ? [
      {
        name: 'My community',
        child: [
          {
            name: 'Contacts',
          },
          {
            name: 'Connections',
          },
          {
            name: 'I Follow',
          },
          {
            name: 'My Followers',
          },
          {
            name: 'Invitations',
          },
          {
            name: 'Groups',
          },
          {
            name: 'My hires',
          },
        ],
      },
      {
        name: 'Professional community',
        child: [
          {
            name: 'Experts',
          },
          {
            name: 'Investors',
          },
          {
            name: 'Companies',
          },
        ],
      },
    ]
  : [
      {
        name: 'Professional community',
        child: [
          {
            name: 'Experts',
          },
          {
            name: 'Investors',
          },
          {
            name: 'Companies',
          },
        ],
      },
    ];

const CommunityPage = () => {
  const [activeTab, setActiveTab] = useState(isProduction ? 0 : 1);
  const [activeChildTab, setActiveChildTab] = useState(0);
  const [activeChildTabName, setActiveChildTabName] = useState('expert');
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeListPage, setActiveListPage] = useState(1);

  useEffect(() => {
    const tabFromUrl = searchParams.get('activeTab');
    const childTabFromUrl = searchParams.get('activeChildTab');
    const activePage = searchParams.get('activePage');
    if (activePage) {
      setActiveListPage(parseInt(activePage, 10));
    } else {
      setActiveListPage(1);
    }
    const findIndexOfTab = TABS.findIndex((item) => item.name === tabFromUrl);
    if (findIndexOfTab !== -1) {
      setActiveTab(findIndexOfTab);
      const findIndexOfChildTab = TABS[findIndexOfTab]?.child?.findIndex(
        (item) => item.name === childTabFromUrl
      );
      if (findIndexOfChildTab !== -1) {
        setActiveChildTab(findIndexOfChildTab);
      }
    }
  }, [searchParams]);

  const changePage = (event, value) => {
    setActiveListPage(value);
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set('activePage', value);
    setSearchParams(newSearchParams);
  };

  useEffect(() => {
    if (activeTab === 1) {
      let roleName = 'expert';
      switch (activeChildTab) {
        case 1:
          roleName = 'investor';
          break;
        case 2:
          roleName = 'companies';
          break;
        default:
          roleName = 'expert';
      }
      setActiveChildTabName(roleName);
    } else {
      setActiveChildTabName(activeChildTab);
    }
  }, [activeTab, activeChildTab]);

  return (
    <Box className={styles.communityContent}>
      <TabSelect
        setActiveTab={setActiveTab}
        activeTab={activeTab}
        setActiveChildTab={setActiveChildTab}
        activeChildTab={activeChildTab}
        options={TABS}
        disableChildTab={loading && activeTab === 1}
      />
      {activeTab === 0 ? (
        <MyCommunityPage
          activeListPage={activeListPage}
          activeTab={activeChildTabName}
          changePage={changePage}
        />
      ) : activeTab === 1 ? (
        <ProfCommunityPage
          setLoading={setLoading}
          loading={loading}
          activeRole={activeChildTabName}
        />
      ) : null}
    </Box>
  );
};
export default CommunityPage;
